import { selectPlaygroundMode, selectPlaygroundWarehouses, updateObjects } from './playgroundSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import React from 'react'

const Alerts: React.FC = () => {
  const mode = useReduxSelector(selectPlaygroundMode)
  return mode === 'base' ? <List /> : null
}

const List: React.FC = () => {
  const warehouses = useReduxSelector(selectPlaygroundWarehouses)
  const list = warehouses.filter(w => w.evilMessage)
  const dispatch = useReduxDispatch()

  return (
    list.length > 0
      ? <div className='playground__alerts'>
        {list.map(({ id, evilMessage, typeId }) => <div
          key={typeId}
          className='playground__alert'>
          <span>{evilMessage}</span>
          <i
            className='icon icon--close'
            onClick={() => {
              id && dispatch(updateObjects({ type: 'warehouses', values: { [id]: { evilMessage: undefined } }}))
          }}/>
        </div>)}
      </div>
      : null
  )
}

export default Alerts